export const tr = {
    'add-minus-keywords-pack-success': 'Dizi oluşturuldu'
};
